import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Process() {
  const steps = ['Ves la masterclass gratuita.', 'Agendas tu llamada de descubrimiento.', 'Conversamos 15–30 minutos sobre tu momento actual.', 'Si tiene sentido, te propongo una sesión 1:1 o un plan de acompañamiento personalizado.'];
  return <section className="py-14 md:py-20 bg-brand-warmwhite border-y border-brand-sand/30" data-id="element-140">
      <div className="max-w-3xl mx-auto px-6" data-id="element-141">
        <FadeIn data-id="element-142">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-brand-ink mb-12 md:mb-16" data-id="element-143">
            Así funciona el proceso
          </h2>
        </FadeIn>

        <ol className="space-y-6" data-id="element-144">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-145">
              <li className="flex items-start gap-5" data-id="element-146">
                <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-brand-sage-light text-brand-eucalyptus font-serif text-lg font-medium" data-id="element-147">
                  {index + 1}
                </span>
                <p className="font-sans text-lg text-brand-ink/80 leading-relaxed pt-1.5" data-id="element-148">
                  {step}
                </p>
              </li>
            </FadeIn>)}
        </ol>
      </div>
    </section>;
}